// extracted by mini-css-extract-plugin
export default {"container":"CardsInfoBanner_container__nEyva","img":"CardsInfoBanner_img__VDI2p","title":"CardsInfoBanner_title__0fUXT","text":"CardsInfoBanner_text__CiNNj"};